import { TargetingMap } from "./getMergedTargeting";

function isProbablyUrlEncoded(value: string): boolean {
  try {
    return decodeURIComponent(value) !== value;
  } catch {
    return false;
  }
}

function encodeOnce(rawValue: string): string {
  const trimmedValue = rawValue.trim();
  if (!trimmedValue) {
    return "";
  }

  return isProbablyUrlEncoded(trimmedValue)
    ? trimmedValue
    : encodeURIComponent(trimmedValue);
}

export function kvsToCustParams(
  kvs: TargetingMap,
  allowlist?: Set<string>,
): string {
  const pairs: string[] = [];

  for (const [key, values] of Object.entries(kvs)) {
    if (allowlist && !allowlist.has(key)) {
      continue;
    }

    const encodedKey = encodeURIComponent(key);

    for (const rawValue of values ?? []) {
      const encodedValue = encodeOnce(String(rawValue));
      if (!encodedValue) {
        continue;
      }

      pairs.push(`${encodedKey}=${encodedValue}`);
    }
  }

  return pairs.join("&");
}
